<template>
  <div class="riclothes-product" style="padding-bottom: 8px;">
    <RiClothesCard v-if="product.id" id="slideCard" style="margin-top: 4px; margin-bottom: 4px; text-align: center;">
      <div class="riclothes-product--item-top-layout">
        <div class="riclothes-product--item-top-layout__vertical" style="flex: 1">
          <RiClothesText class="riclothes-product--item-top-layout--title">{{ product.name }}</RiClothesText>
          <div class="riclothes-product--item-top-layout--tag">
            <p v-for="(tag, index) in product.tags" :key="index">{{ tag }}</p>
          </div>
          <RiClothesText v-if="product.description" style="margin: 0 8px; text-align: center;">{{ product.description }}</RiClothesText>
          <RiClothesButton text="BOOTHで購入する" color="red" buttonType="outline" style="margin: 8px 16px 2px 16px; " :href="product.booth_url" v-if="isEmptyString(product.booth_url)"></RiClothesButton>
          <div class="riclothes-product--dividers"></div>
          <RiClothesText textSize="1.4rem" style="text-align: right;">バリエーション / 値段</RiClothesText>
          <div class="riclothes-product--item-top-layout__vertical riclothes-product--item-top-layout--variation-container" v-for="(variation, index) in product.variation_list" :key="index">
            <RiClothesText class="riclothes-product--item-top-layout--sub-title" style="text-align: center !important;">{{ variation.variation_name }}</RiClothesText>
            <RiClothesText class="riclothes-product--item-top-layout--description" style="text-align: center !important;" v-if="isEmptyString(variation.variation_descriptioon)">{{ variation.variation_descriptioon }}</RiClothesText>
            <RiClothesText class="riclothes-product--item-top-layout--price" style="text-align: center !important;">{{ variation.variation_price }}</RiClothesText>
          </div>
        </div>
        <Hooper ref="hooper" class="riclothes-product--hopper" :wheelControl="false">
        <Slide v-for="(url, index) in imageList" :key="index">
          <RiClothesImage :src="url" style="min-width: 100%; max-width: 100%;" />
        </Slide>

        <hooper-navigation slot="hooper-addons"></hooper-navigation>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </Hooper>
      </div>
    </RiClothesCard>
    <RiClothesCard class="riclothes-product--content" style="margin-top: 12px; margin-bottom: 0px;" v-if="product.id">
      <RiClothesCheckbox :isChecked="false" checkboxId="licence_viewer_checkbox" text="ライセンスを表示する" color="blue" v-model="licenceViewerCheckbox"></RiClothesCheckbox>
      <RiClothesAccordion :isOpen="licenceViewerCheckbox">
        <div>
          <RiClothesCheckbox style="margin-top: 8px;" :isChecked="false" checkboxId="licence_viewer_is_english_checkbox" text="Show English version (英語版を表示する)" color="blue" v-model="isEnglishLicence"></RiClothesCheckbox>
          <RiClothesLicenceViewer :isEnglish="isEnglishLicence" :remarks="product.licence.remarks"></RiClothesLicenceViewer>
        </div>
      </RiClothesAccordion>
    </RiClothesCard>
    <RiClothesCard  v-for="(contentHtml, index) in contentList" :key="index" class="riclothes-product--content">
      <div v-if="isShowAccordionCard(index)">
        <RiClothesCheckbox :checkboxId="`accordion_card_checkbox_${index}`" :text="product.accordion_card_list[index].checkbox_text" color="blue" v-model="product.accordion_card_list[index].isCheck"></RiClothesCheckbox>
        <RiClothesAccordion :isOpen="product.accordion_card_list[index].isCheck">
          <div class="riclothes-product" :class="contetnDivClass" v-html="contentHtml">
          </div>
        </RiClothesAccordion>
      </div>
      <div v-if="!isShowAccordionCard(index)" class="riclothes-product" :class="contetnDivClass" v-html="contentHtml">
      </div>
    </RiClothesCard>

    <RiClothesCard class="riclothes-product--content" style="margin-top: 12px; margin-bottom: 4px;" v-if="product.file_list">
      <RiClothesCheckbox :checkboxId="`file_list_checkbox`" text="内容物一覧を表示する" color="blue" v-model="fileListViewerCheckbox"></RiClothesCheckbox>
      <RiClothesAccordion :isOpen="fileListViewerCheckbox">
        <RiClothesFileViewer :fileList="product.file_list" style="border: 2px var(--riclothes-text-color-disabled) solid; margin-top: 8px;"></RiClothesFileViewer>
      </RiClothesAccordion>
      <div class="riclothes-product--dividers"></div>
    </RiClothesCard>

    <RiClothesCard class="riclothes-product--content" style="margin-top: 12px; margin-bottom: 4px;" v-if="isShowChangelog">
      <RiClothesText textSize="1.6rem">更新履歴</RiClothesText>
      <div v-for="(changelog, index) in product.changelog" :key="index" style="margin-left: 8px; margin-top: 4px">
        <RiClothesText textSize="1.4rem">{{ changelog.version_name }}</RiClothesText>
        <RiClothesText v-for="(log, index) in changelog.log" :key="index" style="margin-left: 8px;">{{ log }}</RiClothesText>
      </div>
    </RiClothesCard>

    <RiClothesCard style="margin-top: 12px; margin-bottom: 4px;" v-if="!product.id">
      <RiClothesText id="loading" textSize="2rem">Loading...</RiClothesText>
    </RiClothesCard>
  </div>
</template>

<script>
import ContentsParser from "@/riclothes/ContentParser.js";
import RiClothesCard from "@/components/RiClothesCard.vue";
import RiClothesText from "../components/RiClothesText";
import RiClothesButton from "../components/RiClothesButton";
import RiClothesLicenceViewer from "../components/RiClothesLicenceViewer";
import RiClothesCheckbox from "../components/RiClothesCheckbox";
import RiClothesAccordion from "../components/RiClothesAccordion";
import RiClothesImage from "../components/RiClothesImage";
import RiClothesFileViewer from "../components/RiClothesFileViewer";

import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: "Product",
  components: {
    RiClothesCard,
    RiClothesText,
    RiClothesButton,
    RiClothesLicenceViewer,
    RiClothesCheckbox,
    RiClothesAccordion,
    RiClothesImage,
    RiClothesFileViewer,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data() {
    return {
      product: {},
      imageList: [],
      contentList: () => { return [] },
      imageSlideWidth: "0px",
      licenceViewerCheckbox: false,
      fileListViewerCheckbox: false,
      isEnglishLicence: false
    }
  },

  computed: {
    isEmptyString() {
      return (str) => {
        return (str != "" && str != undefined && str != null)
      };
    },
    isShowChangelog() {
      if(this.product.changelog == undefined && this.product.changelog == null) {
        return false;
      } else if (this.product.changelog.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    contetnDivClass() {
      return {
        dark: this.$root.config.isDarkTheme
      }
    },
    isShowAccordionCard() {
      return (index) => {
        if(this.product.accordion_card_list == undefined || this.product.accordion_card_list == null || this.product.accordion_card_list.length == 0) {
          return false;
        }
        const accordionCardObject = this.product.accordion_card_list[index];
        if(accordionCardObject != undefined && accordionCardObject != null) {
          return Object.hasOwnProperty.call(accordionCardObject, "checkbox_text");
        } else {
          return false;
        }
      }
    }
  },

  mounted() {
    let reSizeTimer = 0;
    window.onresize = () => {
      if(reSizeTimer > 0) {
        clearTimeout(reSizeTimer);
      }

      reSizeTimer = setTimeout(() => {
        this.$refs.hooper.updateWidth();
      }, 500);
    }
    const paramsId = this.$route.params.id;
    fetch(`/products/${paramsId}/product.json`, { method: "GET" }).then(response => response.text()).then(text => {
      this.product = JSON.parse(text);
      document.title = `${this.product.name} - RiClothes Website`;
      if(this.product.image_list != undefined && this.product.image_list != null) {
        for(let i = 0; i < this.product.image_list.length; i++) {
          const url = this.product.image_list[i];
          const urlRegex = /https?:\/\//g;
          if(!urlRegex.test(url)) {
            this.imageList.push(`/products/${this.product.id}/images/${url}`);
          } else {
            this.imageList.push(url);
          }
        }
      }
      return fetch(`/products/${paramsId}/content.txt`, { method: "GET" }).then(contentResponse => contentResponse.text());
    }).then(contentText => {
      const parseContent = ContentsParser.parse(contentText);
      this.contentList = parseContent.split(/\$next_card/g);
    }).catch((error) => {
      document.getElementById("loading").textContent = "Error: " + error;
    });
  }
}
</script>

<style lang="scss">
.riclothes-product {
  --tag-chip-background-color: #e0e0e0;
  & > p {
    text-align: left;
    white-space: pre-wrap;
    word-break: break-all;
    padding: 0px;
    margin: 0px 2px;
  }
  --riclothes-text-color-high: #212121;
  --riclothes-text-color-medium: #666666;
  --riclothes-text-color-disabled: #9e9e9e;

  color: var(--riclothes-text-color-high);

  &--content {
    margin-top: 12px;
    margin-bottom: 4px;
    background: none !important;
    box-shadow: none !important;
    padding: 0px !important;
  }

  &--title {
    font-size: 1.5rem;
    color: var(--riclothes-text-color-high);
    margin: 0px;
    padding: 0px;
  }

  &--url {
    text-decoration: none;
    color: var(--color-light-blue);
  }

  &--img {
    width: 85%;
    max-width: 560px;
  }

  &--video {
    width: 100%;
    padding-bottom: min(56.25%, 315px);
    height:0px;
    position: relative;
    max-width: 560px;
    & > iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &--dividers {
    margin: 8px 4px;
    border-top: var(--riclothes-text-color-disabled) solid 1px;
  }

  &--item-top-layout {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-start;
    &__vertical {
      display: flex;
      flex-direction: column;
    }

    &--variation-container {
      border: var(--riclothes-text-color-disabled) solid 2px;
      border-radius: 4px;
      margin-top: 6px;
      margin-right: 2px;
      margin-left: 8px;
      padding: 4px;
    }

    &--title {
      font-size: 1.8rem !important;
      margin: 0 8px !important;
      margin-top: 8px !important;
      text-align: right !important;
      transition: 0.5s;
    }
    &--sub-title {
      font-size: 1.6rem !important;
      margin: 0 8px !important;
      margin-top: 4px !important;
      text-align: right !important;
      transition: 0.5s;
    }
    &--description {
      font-size: 1rem !important;
      text-align: right !important;
    }
    &--price {
      text-align: right !important;
      color: var(--color-blue) !important;
      font-size: 1.8rem !important;
      transition: 0.5s;
    }
    &--tag {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      flex-wrap: wrap;
      & > p {
        display: inline-block;
        margin: 0px;
        margin-left: 6px;
        margin-top: 4px;
        padding-left: 4px;
        padding-right: 6px;
        padding-top: 6px;
        padding-bottom: 6px;
        border-radius: 4px;
        font-size: 1rem;
        background-color: var(--tag-chip-background-color);
        color: var(--riclothes-text-color-medium);
        transition: 0.5s;
      }
    }
  }
  &--hopper {
    display: inline-block;
    max-width: 50%;
    height: auto
  }
}

.dark {
  --riclothes-text-color-high: #e0e0e0;
  --riclothes-text-color-medium: #c0c0c0;
  --riclothes-text-color-disabled: #6c6c6c;
  --tag-chip-background-color: #3d3d3d;
}

.hooper-indicator {
  background: var(--surface-color);
  transition: all 0.2s;
  border: var(--text-color) solid 1.5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0 6px;
  &.is-active {
    background: var(--color-blue);
  }
  &:hover {
    background: rgba(var(--color-blue-rgb), 0.4);
  }
}

.hooper-next,
.hooper-prev {
  color: #000000;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 4px;
  border: #000000 solid 1.5px;
}


@media screen and (max-width: 599px) {
  .riclothes-product {
    &--item-top-layout {
      flex-direction: column-reverse;
    }
    &--hopper {
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 896px) {
  .riclothes-product {
    &--content {
      width: 96% !important;
    }
  }
}
</style>